import { CHART_INTERVAL_OPTIONS } from '../components/shared/ChartIntervalControl';

/** Compact label for the same bar size ChartIntervalControl calls "5 Min". */
export function compactIntervalLabel(option) {
  if (option.unit === 'Minute') {
    if (option.interval % 60 === 0) return `${option.interval / 60}h`;
    return `${option.interval}m`;
  }
  if (option.unit === 'Daily') return '1D';
  if (option.unit === 'Weekly') return '1W';
  if (option.unit === 'Monthly') return '1M';
  return option.display;
}

/** Stable picker value. Minute sizes use the minute count; daily/weekly/monthly stay D/W/M. */
export function compactIntervalValue(option) {
  if (option.unit === 'Daily') return 'D';
  if (option.unit === 'Weekly') return 'W';
  if (option.unit === 'Monthly') return 'M';
  return String(option.interval);
}

/** Same intervals as the trade chart, with the short labels used on mobile and position cards. */
export const POSITION_CHART_TIMEFRAMES = CHART_INTERVAL_OPTIONS.map((option) => ({
  value: compactIntervalValue(option),
  label: compactIntervalLabel(option),
  interval: option.interval,
  unit: option.unit,
  display: option.display,
}));

export const DEFAULT_POSITION_CHART_TIMEFRAME = 'D';
